import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaTiktok, FaYoutube } from "react-icons/fa";
import "./footer.scss";

export default function Footer() {
  return (
    <footer>
      <div className="container">
        {/* === Footer Grid Sections === */}
        <div className="site-footer">
          {/* Company */}
          <div>
            <h3>Company</h3>
            <ul>
              <li>
                <Link to="/about-us">About Us</Link>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/teleport-now/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Careers
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3>Services</h3>
            <ul>
              <li><Link to="/esim">eSIM</Link></li>
              <li><Link to="/flights">Flights</Link></li>
              <li><Link to="/things-to-do">Things To Do</Link></li>
              <li><Link to="/airport-lounges">Airport Lounges</Link></li>
            </ul>
          </div>

          {/* Collaborations */}
          <div>
            <h3>Collaborations</h3>
            <ul>
              <li>
                <a
                  href="https://affiliate.teleportapp.sg/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Affiliates
                </a>
              </li>
              <li>
                <a
                  href="https://www.merchants.teleportapp.sg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Merchants
                </a>
              </li>
              <li>
                <a
                  href="https://shopee.sg/teleportnow"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Shopee
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3>Support</h3>
            <ul>
              <li>
                <Link to="/help-center">Help Center</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact Us</Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3>Legal</h3>
            <ul>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* === Divider and Bottom Section === */}
        <div className="footer-bottom">
          <div className="footer-brand">
            <img
              src="/images/Android.png"
              alt="Teleport Now Logo"
              className="footer-logo"
              width="48"
              height="48"
            />
            <span>Teleport Now</span>
          </div>

          <p className="copyright">
            © {new Date().getFullYear()} Teleport Now. All rights reserved.
          </p>

          <div className="social-icons">
            <a
              href="https://facebook.com/teleportnowsg"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/teleport_now/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.tiktok.com/@teleportnowsg"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
            >
              <FaTiktok />
            </a>
            <a
              href="https://www.youtube.com/@teleportnowsg"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
